module.exports = __webpack_public_path__ + "static/media/createTaskInactive.0c7e5ed3.png";